import React from "react";

const VideosINE = () => {
  const videoGroups = [
    [
      {
        id: "jvOZFERXuiM",
        title: "Cápsula en Náhuatl",
        url: "https://youtu.be/jvOZFERXuiM"
      },
      {
        id: "EEHZkyv-sTE",
        title: "Cápsula en Yuhmú (variante del Otomí)",
        url: "https://youtu.be/EEHZkyv-sTE",
        isIframe: true
      },
      {
        id: "SvfEVaA6jF8",
        title: "Votación de Personas con Discapacidad",
        url: "https://youtu.be/SvfEVaA6jF8"
      }
    ],
    [
      {
        id: "7sg3kvUYxRY",
        title: "Voto de Personas con Discapacidad Trans, No Binarias",
        url: "https://youtu.be/7sg3kvUYxRY"
      },
      {
        id: "dizDZWMNJxE",
        title: "Proceso de Votación de las Personas con Discapacidad",
        url: "https://youtu.be/dizDZWMNJxE"
      },
      {
        id: "r9X_4Jlju3E",
        title: "Consulta Infantil y Juvenil 2024",
        url: "https://youtu.be/r9X_4Jlju3E"
      }
    ]
  ];

  return (
    <div className="mt-5 container">
 
      <div
        id="carouselVideosINE"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {videoGroups.map((group, groupIndex) => (
            <div 
              className={`carousel-item ${groupIndex === 0 ? 'active' : ''}`}
              key={`group-${groupIndex}`}
            >
              <div className="row justify-content-center">
                {group.map((video, videoIndex) => (
                  <div className="col-md-4" key={`video-${groupIndex}-${videoIndex}`}>
                    <div className="Home__video-embed ratio ratio-16x9 w-100">
                      {video.isIframe ? (
                        <iframe
                          src={`https://www.youtube-nocookie.com/embed/${video.id}`}
                          title={video.title}
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <lite-youtube
                          videoid={video.id}
                          playlabel={video.title}
                          nocookie
                        ></lite-youtube>
                      )}
                    </div>
                    <a
                      href={video.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <h5 className="mt-3 text-center">{video.title}</h5>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselVideosINE"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselVideosINE"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </div>
  );
};

export default VideosINE;